import { DsquaresLogo } from "src/assets/Icons";
import ModulesMenu from "../../ModulesMenu/ModulesMenu";
import UserPoints from "../../UserPoints/UserPoints";
import BurgerMenu from "../../BurgerMenu/BurgerMenu";
import { Link } from "react-router-dom";

export default function NavBarWeb() {
  return (
    <div className="flex items-center justify-between gap-5 px-5 py-5 bg-background-default w-full" dir="ltr">
      <div className="flex-1">
        <Link className="flex items-center justify-center" to="/">
          <DsquaresLogo className="aspect-auto h-12" />
        </Link>
      </div>
      <div className="flex-5 flex min-w-0 items-center justify-center w-full">
        <ModulesMenu/>
      </div>
      <div className="flex-1 flex items-center gap-2">
        <UserPoints/>
        <BurgerMenu/>
      </div>
    </div>
  );
}
